import Vue from 'vue';
import App from './App.vue';
import Firebase from 'firebase';
import VueRouter from 'vue-router';
import { store } from './store/store';
import { routes } from './router/routes';

// Firebase config - this is provided when you create your app
// Swap out these settings for your project settings
const config = {
  apiKey: "AIzaSyDaZPrmMngLgimzxFQrtI_8ColS5bADUOM",
  authDomain: "combine-c5849.firebaseapp.com",
  databaseURL: "https://combine-c5849.firebaseio.com",
  projectId: "combine-c5849",
  storageBucket: "combine-c5849.appspot.com",
  messagingSenderId: "52926773476"
};

// Initialize Firebase
let app = Firebase.initializeApp(config);


// Set-up and use the Vue Router
// Pass in your routes and then
// Set the mode to use history
// removes # from the URL
Vue.use(VueRouter);

var VueFire = require("vuefire");
Vue.use(VueFire);



const router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
});


window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//LODASH
// Load the full build.
var _ = require('lodash');
// Load the core build.
var _ = require('lodash/core');
// Load the FP build for immutable auto-curried iteratee-first data-last methods.
var fp = require('lodash/fp');

// Load method categories.
var array = require('lodash/array');
var object = require('lodash/fp/object');

// Cherry-pick methods for smaller browserify/rollup/webpack bundles.
var at = require('lodash/at');
var curryN = require('lodash/fp/curryN');
//END LODASH

// Check before each page load whether the page requires authentication/
// if it does check whether the user is signed into the web app or
// redirect to the sign-in page to enable them to sign-in

router.beforeEach((to, from, next) => {

  const currentUser = Firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);


  if (requiresAuth && !currentUser) {
    next();
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }

});

// Wrap the vue instance in a Firebase onAuthStateChanged method
// This stops the execution of the navigation guard 'beforeEach'
// method until the Firebase initialization ends

Firebase.auth().onAuthStateChanged(function (user) {

  new Vue({
    el: '#app',
    store: store,
    router: router,
    render: h => h(App),
    created() {
      Firebase.auth().onAuthStateChanged((user) => {
          /*  if(user) {
             this.$router.push('/user')
            } else {
             window.location.replace('https://combine.no'+'/order/')
           }*/
           });
    }
  });

});



// WEBPACK FOOTER //
// ./src/main.js